import { API, API_POST } from "../../../Config";

export const handleEditDiet = (payload, id) => {
  
  const f = new FormData();
  f.append("id", id);
  f.append("title", payload.title);
  f.append("photo", payload.image);
  f.append("recipe_ids", payload.recipe_id);

  return API_POST(API.EditDiet, f);
};
